module.exports = __webpack_public_path__ + "static/img/9.1c554b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/9.png
// module id = KO9G
// module chunks = 0